<template>
  <div class="mood-height mood-vertical-distance">
    <div class="mood_layer hidden-xs hidden-sm" :style="{ '--color' : mood.non_repeat.background_color }">
      <div class="container">
        <div class="row p-100">
          <div class="col-md-6">
            <div class="backgroundColor mood-image-container" :style="{ '--color' : mood.non_repeat.imageBackground_color}">
              <img id="moodImage" class="img-fluid lazy" :data-src="mood.non_repeat.image" alt="">
            </div>
          </div>
          <div class="col-md-6">
            <div id="moodTitle" class="mood-title title-color" :style="{ '--color' : mood.non_repeat.titleColor}"
                 v-html="mood.non_repeat.title">
            </div>
            <div id="mood-desktop" class="moodSplide">
              <div class="splide__arrows">
                <button class="splide__arrow splide__arrow--prev mood_layer">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40" width="40" height="40">
                    <path
                      d="m15.5 0.932-4.3 4.38 14.5 14.6-14.5 14.5 4.3 4.4 14.6-14.6 4.4-4.3-4.4-4.4-14.6-14.6z">
                    </path>
                  </svg>
                </button>
                <div class="text-arrow">
                  <span class="mood-index-desktop" id="mood-index-desktop"></span> von <span class="mood-length-desktop" id="mood-length-desktop"></span>
                </div>
                <button class="splide__arrow splide__arrow--next mood_layer">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40" width="40" height="40">
                    <path
                      d="m15.5 0.932-4.3 4.38 14.5 14.6-14.5 14.5 4.3 4.4 14.6-14.6 4.4-4.3-4.4-4.4-14.6-14.6z">
                    </path>
                  </svg>
                </button>
              </div>
              <div class="splide__track">
                <ul class="splide__list">
                  <li class="splide__slide" v-for="(repeatables, index) in mood.repeat" :key="'repeatable-' + index">
                    <div class="card">
                      <img id="moodIcon" class="card-image lazy" :data-src="repeatables['card_icon']">
                      <div class="card-body">
                        <h2 id="moodCardTitle" v-html="repeatables['card_title']"></h2>
                        <p id="moodCardDescription" v-html="repeatables['card_text']">
                        </p>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="fullHeight">
      <div id="moodImageMob" class="mood-mobile lazy-style-attribute visible-xs visible-sm" :data-src="mood.non_repeat.image" :data-style-attribute='"--header-image-url"'>
        <div class="mood-layer-mob" :style="{ '--color' : mood.non_repeat.background_color }">
        </div>
        <div class="mood-parent">
          <div id="moodTitleMob" class="mood-title title-color" :style="{ '--color' : mood.non_repeat.titleColor}"
               v-html="mood.non_repeat.title"></div>
          <div id="mood-slider-mob" class="mobileMoodSplide">
            <div class="splide__arrows">
              <button class="splide__arrow splide__arrow--prev mood_layer">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40" width="40" height="40">
                  <path
                    d="m15.5 0.932-4.3 4.38 14.5 14.6-14.5 14.5 4.3 4.4 14.6-14.6 4.4-4.3-4.4-4.4-14.6-14.6z">
                  </path>
                </svg>
              </button>
              <div class="text-arrow">
                <span id="mood-index-mob" class="mood-index-mob"></span> von <span id="mood-length-mob" class="mood-length-mob"></span>
              </div>
              <button class="splide__arrow splide__arrow--next mood_layer">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40" width="40" height="40">
                  <path
                    d="m15.5 0.932-4.3 4.38 14.5 14.6-14.5 14.5 4.3 4.4 14.6-14.6 4.4-4.3-4.4-4.4-14.6-14.6z">
                  </path>
                </svg>
              </button>
            </div>
            <div class="splide__track">
              <ul class="splide__list">
                <li class="splide__slide" v-for="(repeatables, index) in mood.repeat" :key="'repeatable-' + index">
                  <div class="card">
                    <img id="moodIconMob" class="card-image"
                         :src="repeatables['card_icon']">
                    <div class="card-body">
                      <h2 id="moodCardTitleMob" v-html="repeatables['card_title']"></h2>
                      <p id="moodCardTextMob" v-html="repeatables['card_text']">
                      </p>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "MoodSection",
  props: ['mood'],
}
</script>

<style scoped lang="scss">
@import "../../css/variables.scss";

.mood_layer {
    background-color: var(--color);
}

.backgroundColor{
  width: 418px;
  height: 500px;
  margin-left: 163px;
  margin-top: 75px;
  background-color: var(--color);
}

.mood-mobile {
    height: 100%;
    position: relative;
    background-image: var(--header-image-url);
    background-repeat: no-repeat;
    max-width: 100%;
    background-size: cover;
}

.mood-layer-mob {
    position: absolute;
    background-color: var(--color);
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0.9;
}

.splide__arrows {
  color: $color-jungle-green;
}

@media (max-width: 767px) {
  .mood-height{
    height: 770px !important;
  }
}
.mood-height {
  height: 800px;
}

.mood-parent {
  position: relative;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.p-100 {
  padding-bottom: 100px;
}

.mood-image-container {
  height: 470px;
  width: 320px;
}

.img-fluid {
  height: 470px;
  width: 320px;
  border-bottom-right-radius:12.5rem;
}

.card {
  position: relative;
  margin-top: 46px;
}

.card-image {
  position: absolute;
  top: -40px;
  width: 76px;
  left: 15px;
}

.card-body {
  border: 2px solid white;
  padding: 20px;
  background-color: white;
  border-radius: 10px;
  height: 300px;
  color:$color-jungle-green;
}

.splide__arrow {
  top: 120%;
  border: 2px solid $color-jungle-green;
  border-radius: 10px;
}

.splide__arrow--prev {
  left: 0;
}

.splide__arrow--next {
  left: 15rem;
}

.text-arrow {
  position: absolute;
  top: 116%;
  left: 8rem;
  font-family: "open sans";
  font-size: 12px;
  font-weight: bold;
}

.mood-vertical-distance {
  margin-top: 138px;
}
.splide__arrow {
  top: 120%;
  border: 1px solid $color-jungle-green;
  border-radius: 0;
  width: 54px;
  height: 54px;
}

@media (min-width: 1439px) {
  .mood-title {
    margin-top: 14rem;
  }
}

@media (min-width: 1920px) {
  .img-fluid {
    border-bottom-right-radius:12.5rem;
  }
}

@media (min-width: 1024px) and (max-width: 1439px) {
  .img-fluid {
    width: 320px;
    height: 470px;
    border-bottom-right-radius:12.5rem;
  }
  .backgroundColor{
    width: 320px;
    height: 470px;
    margin-left: 129px;
    margin-top: 40px;
    background-color: var(--color);
  }
}

@media (min-width: 768px) and (max-width: 1024px) {
  .mood-height {
    margin-bottom: 25rem;
  }

  .card-body {
    height: 400px;
  }

  .mood-title {
    margin-top: 0;
    margin-left: 50px;
  }

  .text-arrow {
    left: 8em;
    top: 107%;
  }

  .splide__arrow--prev {
    left: 2em;
  }

  .splide__arrow--next {
    left: 11em;
  }

  .splide {
    margin-left: 20px;
  }

  .splide__arrow {
    top: 110%;
  }

  .img-fluid {
    width: 320px;
    height: 470px;
    border-bottom-right-radius:12.5rem;
  }
  .backgroundColor{
    width: 320px;
    height: 470px;
    margin-left: 129px;
    margin-top: 90px;
    background-color: var(--color);
  }
}

@media (max-width: 767px) {
  .mood-parent {
    height: 68%;
  }

  .mood-title {
    margin-left: 15px;
    margin-right: 15px;
    margin-top: 140px;
  }

  .card-body {
    margin-left: 20px;
    height: 310px;
  }

  .splide__arrow--prev {
    left: 2em;
  }

  .splide__arrow--next {
    left: 12em;
  }

  .text-arrow {
    left: 10rem;
    margin-top: 3px;
  }

  .card-image {
    width: 50px;
    top: -27px;
    left: 33px;
  }
  .mood-vertical-distance {
    margin-top: 70px;
  }
}

.fullHeight {
    height: 100%;
}
</style>
